import SidebarLogo from "./SidebarLogo";
import SidebarTopClinic from "./SidebarTopClinic";
import SidebarMenu from "./SidebarMenu";

export default function Sidebar() {
  return (
    <div className="sidebar" id="sidebar">
      <SidebarLogo />
      <div className="sidebar-inner" data-simplebar>
        <div id="sidebar-menu" className="sidebar-menu">
          <SidebarTopClinic />
          <SidebarMenu />
        </div>
      </div>
    </div>
  );
}
